import { mutatorAction } from 'satcheljs';
export default mutatorAction('setMultiSelectionAnchorRowKey', function setMultiSelectionAnchorRowKey(tableView, newMultiSelectionAnchorRowKey) {
    tableView.multiSelectionAnchorRowKey = newMultiSelectionAnchorRowKey;
});
//# sourceMappingURL=setMultiSelectionAnchorRowKey.js.map